import {
  STEP_2_FORM_FAILED,
  STEP_2_FORM_REQ,
  STEP_2_FORM_SUCCESS,
  STEP_3_FORM_FAILED,
  STEP_3_FORM_REQ,
  STEP_3_FORM_RESET,
  STEP_3_FORM_SUCCESS,
  TLAT_DETAILS_FORM_FAILED,
  TLAT_DETAILS_FORM_REQ,
  TLAT_DETAILS_FORM_SUCCESS,
} from "../Constant/FreeClassConctant";

export const Form2SubmitReducer = (state = {}, { type, payload, URL }) => {
  switch (type) {
    case STEP_2_FORM_REQ: {
      return { loading: true };
    }

    case STEP_2_FORM_SUCCESS: {
      return { loading: false, success: payload, URL };
    }

    case STEP_2_FORM_FAILED: {
        console.log(payload)
      {
        return { loading: false, error: payload };
      }
    }
    default:
      return state;
  }
};

export const Form3SubmitReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case STEP_3_FORM_REQ: {
      return { loading: true };
    }

    case STEP_3_FORM_SUCCESS: {
      return { loading: false, success: payload };
    }

    case STEP_3_FORM_FAILED: {
        console.log(payload,"rdc")
      return { loading: false, error: payload };
    }

    case STEP_3_FORM_RESET: {
      return { loading: false, error: "" };
    }
    default:
      return state;
  }
};

export const DetailsTestReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case TLAT_DETAILS_FORM_REQ: {
      return { loading: true };
    }

    case TLAT_DETAILS_FORM_SUCCESS: {
      return { loading: false, detTLAT: payload };
    }
    case TLAT_DETAILS_FORM_FAILED: {
      return { loading: false, error: payload };
    }
    default:
      return state;
  }
};
